// Prompt 81 — Global panel wrapper for the two-mode Credit Note form. Rendered in the
// ProcurementPage PANEL SLOT (between nav and tab content) when showCreditNotePanel is
// true; pre-filled per entry point (supplier detail, OperationDetailView, Payables,
// Finance>Payment). The GIT tab uses CreditNoteForm inline instead (Mode-1 preview
// belongs in the op's context).
import React from 'react';
import CreditNoteForm from './CreditNoteForm';

import { Emo } from '../../shell/EmojiIcons';
import { CloseBtn } from '../GhostBits';
export default function CreditNoteEntryPanel({
  open,
  onClose,
  onSuccess,
  initialPartnerId = '',
  initialOperationId = '',
  initialMode = 'apply_to_goods',
  lockPartner = false,
  lockOrder = false,
  embedded = false,   // rendered inside the unified Data Entry panel → drop card chrome + title
}) {
  if (!open) return null;
  return (
    <div style={embedded ? { padding: 0 } : panelStyle}>
      <div style={{ ...panelTitle, display: embedded ? 'none' : undefined }}>
        <Emo name="invoice" /> Record Credit Note
        <CloseBtn onClick={onClose} style={{ marginLeft: 'auto' }} />
      </div>
      <CreditNoteForm
        key={`${initialPartnerId}|${initialOperationId}|${initialMode}`}
        initialPartnerId={initialPartnerId}
        initialOperationId={initialOperationId}
        initialMode={initialMode}
        lockPartner={lockPartner}
        lockOrder={lockOrder}
        onSuccess={onSuccess}
      />
    </div>
  );
}

const panelStyle = {
  background: '#fff', boxShadow: '0 2px 12px rgba(0,0,0,0.10)', borderRadius: 8,
  padding: 20, marginBottom: 16, border: '1px solid #e4e8e3',
};
const panelTitle = {
  display: 'flex', alignItems: 'center', gap: 8, fontSize: 15, fontWeight: 700,
  color: '#1e293b', marginBottom: 16,
};
